export interface QuickBooksResourceCountsConstructor {
  importable: Nullable<number>
  imported: Nullable<number>
  exportable: Nullable<number>
  exported: Nullable<number>
  archived: Nullable<number>
}

export class QuickBooksResourceCounts {
  readonly importable: Nullable<number>
  readonly imported: Nullable<number>
  readonly exportable: Nullable<number>
  readonly exported: Nullable<number>
  readonly archived: Nullable<number>

  constructor(data: QuickBooksResourceCountsConstructor) {
    this.importable = data.importable
    this.imported = data.imported
    this.exportable = data.exportable
    this.exported = data.exported
    this.archived = data.archived
  }
}
